import { Injectable, inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateChildFn, CanActivateFn, Router, RouterStateSnapshot } from '@angular/router';
import { RelationTypeService } from '@app/modules/relation-type/services/relation-type.service';
import { catchError, map, tap } from 'rxjs/operators';
import * as RelationTypeApiActions from '@app/modules/relation-type/actions/relation-type-api.actions';
import { Store } from '@ngrx/store';
import { State } from '@app/reducers';

export const canActivate: CanActivateFn = (
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
) => {
    const relationTypeService = inject(RelationTypeService);
    const router = inject(Router);
    const store = inject(Store<State>);

    return relationTypeService.get(route.params['id']).pipe(
        map(relationType => RelationTypeApiActions.GetSuccess(relationType)),
        tap((action: any) => store.dispatch(action)),
        map(relationType => !!relationType),
        catchError(() => {
            return router.navigate(['/not-found']);
        })
    );
};

export const canActivateChild: CanActivateChildFn = (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => canActivate(route, state);